import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Dialog from './dialog';
import { getScript, getUserid, getSid } from '@ifeng-fe/container_content/common/client/utils/utils';

class Share extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
        content: PropTypes.array,
    };
    state = {
        isShow: false,
    };

    iconClickHandle = () => {
        if (!this.state.isShow) {
            const tongji = `http://stadig.ifeng.com/actsta.js?datatype=wap_act&value=article_share1&uri=${encodeURIComponent(
                window.location.href,
            )}&ref=${encodeURIComponent(window.location.href)}&uid=${encodeURIComponent(
                getUserid(),
            )}&sid=${getSid()}&time=${encodeURIComponent(new Date().valueOf())}&pt=`;

            getScript(tongji);
        }

        this.setState({
            isShow: !this.state.isShow,
        });
    };

    render() {
        const { isShow } = this.state;
        const { docData, content } = this.props;

        return [
            <div key="shareIcon" className={styles.shareIcon} onClick={this.iconClickHandle} />,
            isShow ? (
                <Dialog key="shareBox" content={content} docData={docData} closeFn={this.iconClickHandle} />
            ) : null,
        ];
    }
}

export default errorBoundary(Share);
